module.exports = __webpack_public_path__ + "static/img/active5.78d2f3d3.png";